
export class DataForEnrolmentModificationDto {

    behaviourPatternModificationCode!: number;

}
